import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 实时数据http://192.168.124.150:19000
 **********************************************************************************/
export default {
	/**
	 * 获取工程配置
	 */
	getWebConfig: (styleName,success, failure) => {
		Axios.post('/system/getWebConfig.do', {
			styleName,
		}, success, failure);
	},
	/**
	 * 获取sysytemConfig.js的配置
	 */
	getWebConifgTwo:(success,failure)=>{
		Axios.post('/system/getWebConfigTwo.do', {}, success, failure);
	},
	/**
	 * 写入sysytemConfig.js的配置
	 */
	setWebConifg:(content,success,failure)=>{
		Axios.post('/system/setWebConfig.do', {
			content,
		}, success, failure);
	}

}
